var _defs, _path, _path2, _rect, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1e1e8;}.cls-2{fill:#141f38;}.cls-3{fill:#ff5f6e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "newspaper-2-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.05,85.33V472.62a32.83,32.83,0,0,1-32.82,32.82H131.28a32.83,32.83,0,0,1-32.82-32.82V39.38A32.83,32.83,0,0,1,131.28,6.56h256Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.23,512H131.28A39.43,39.43,0,0,1,91.9,472.62V39.38A39.43,39.43,0,0,1,131.28,0H390l82.62,82.62v390A39.43,39.43,0,0,1,433.23,512ZM131.28,13.13A26.28,26.28,0,0,0,105,39.38V472.62a26.28,26.28,0,0,0,26.26,26.26H433.23a26.28,26.28,0,0,0,26.26-26.26V88.05L384.56,13.13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.23,
    y: 374.15,
    width: 78.77,
    height: 52.51
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.56,433.23h-91.9V367.59h91.9ZM183.79,420.1h65.64V380.72H183.79Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "466.05 85.33 387.28 85.33 387.28 6.56 466.05 85.33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M466.05,91.9H387.28a6.56,6.56,0,0,1-6.56-6.56V6.56a6.56,6.56,0,0,1,11.21-4.64l78.77,78.77a6.56,6.56,0,0,1-4.64,11.21ZM393.85,78.77H450.2L393.85,22.41Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.38,91.9H177.23a6.56,6.56,0,1,1,0-13.13H295.38a6.56,6.56,0,1,1,0,13.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.28,170.67H177.23a6.56,6.56,0,0,1,0-13.13H387.28a6.56,6.56,0,0,1,0,13.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256,223.18H177.23a6.56,6.56,0,1,1,0-13.13H256a6.56,6.56,0,1,1,0,13.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.28,223.18H308.51a6.56,6.56,0,0,1,0-13.13h78.77a6.56,6.56,0,1,1,0,13.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256,275.69H177.23a6.56,6.56,0,1,1,0-13.13H256a6.56,6.56,0,1,1,0,13.13Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.28,275.69H308.51a6.56,6.56,0,0,1,0-13.13h78.77a6.56,6.56,0,1,1,0,13.13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.28,328.21H177.23a6.56,6.56,0,1,1,0-13.13H387.28a6.56,6.56,0,1,1,0,13.13Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.28,380.72H308.51a6.56,6.56,0,0,1,0-13.13h78.77a6.56,6.56,0,1,1,0,13.13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.28,433.23H308.51a6.56,6.56,0,0,1,0-13.13h78.77a6.56,6.56,0,1,1,0,13.13Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.46,472.62V39.38A32.83,32.83,0,0,1,131.28,6.56H78.77A32.83,32.83,0,0,0,45.95,39.38V472.62a32.83,32.83,0,0,0,32.82,32.82h52.51A32.83,32.83,0,0,1,98.46,472.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.28,512H78.77a39.43,39.43,0,0,1-39.38-39.38V39.38A39.43,39.43,0,0,1,78.77,0h52.51V13.13A26.28,26.28,0,0,0,105,39.38V472.62a26.28,26.28,0,0,0,26.26,26.26ZM78.77,13.13A26.28,26.28,0,0,0,52.51,39.38V472.62a26.28,26.28,0,0,0,26.26,26.26h23.18A39.25,39.25,0,0,1,91.9,472.62V39.38a39.25,39.25,0,0,1,10.05-26.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/Resume.33e912d45b4965d35a25a156ee697e1a.svg";
export { ForwardRef as ReactComponent };